import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';

export interface Project {
  id: number;
  title: string;
  content: string;
  departments: Department[];
  labs: Lab[];
  projectThemes: ProjectTheme[];
  eyecatch: string;
  squareEyecatch: string;
  creators: Creator[];
  terms: Term[];
  pageviews: number;
}
export interface Projects {
  projects: Project[];
}

export interface Creator {
  creator_name: string;
  creator_profile: string;
}

export interface ProjectTheme{
  name: string;
  link: string;
}

export interface Lab {
  name: string;
  link: string;
}

export interface Department {
  name: string;
  link: string;
}
export interface Term {
  name: string;
}

@Module({ dynamic: true, store, name: 'projectstore' })
class ProjectStore extends VuexModule implements Projects {
  public projects = [] as Project[];

  @Action
  public setProjects(projects: Project[]) {
    this.SET_PROJECTS(projects);
  }

  @Mutation
  private SET_PROJECTS(projects: Project[]) {
    this.projects = projects;
  }

}
export const ProjectModule = getModule(ProjectStore);
